import $ from 'jquery';
import PubSub from 'pubsub-js';
import 'slick-carousel';
var AboutModalContent = function(){
	var $section = $('#AboutModalContent');
	if( $section.length < 1 ) return false;



	PubSub.subscribe('modalopen', updateGalleries);
	PubSub.subscribe('modalclose', removeGalleries);

	function updateGalleries() {
		console.log('update galleries');
		$section.find('.js-about-gallery').slick({
			arrows: false,
			infinite: true,
	  	speed: 1000,
	  	fade: true,
	  	autoplay: true,
	  	autoplaySpeed: 5000
		});
	}

	function removeGalleries() {
		$section.find('.js-about-gallery').slick('unslick');
	}
};

export default AboutModalContent();